import { render, staticRenderFns } from "./TrainReservation.vue?vue&type=template&id=758df70a&scoped=true"
import script from "./TrainReservation.vue?vue&type=script&lang=js"
export * from "./TrainReservation.vue?vue&type=script&lang=js"
import style0 from "./TrainReservation.vue?vue&type=style&index=0&id=758df70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758df70a",
  null
  
)

export default component.exports